/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useTableData } from "../data/useTableData";
import { useAgGridTransformerStockUseRatio } from "../transformers/useAgGridTransformerStockUseRatio";
import { useAgGridTransformerMonthOfSupply } from "../transformers/useAgGridTransformerMonthOfSupply";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { ComponentContextReadyState } from "@sa/rep-core";
import { Table } from "../../../components/Table";
import { debounceTime } from "rxjs/operators";
import { useExportSource } from "../hooks/useExportSource";
import { useLastPrice } from "../hooks/useLastPrice";
import "./custom-table.css";
import { useSubscriptionSource } from "../../../shared";

export const ComponentTables: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResultChart = useHookSubscribe(null, context.olapResultChart$);
  const olapResultTable = useHookSubscribe(null, context.olapResultTable$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource(source);
  useSubscriptionSource(source);

  const tableData = useTableData(olapResultTable);
  const agGridDataStockUseRatio = useAgGridTransformerStockUseRatio(tableData);
  const agGridDataMonthOfSupply = useAgGridTransformerMonthOfSupply(tableData);

  const chartData = useTableData(olapResultChart);
  const { price, monthShortName } = useLastPrice(chartData);

  if (window["exportMode"]) {
    window["exportReady"] = !loading && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (loading) {
    return <ComponentPreloader />;
  }

  const lastPriceTitle = price ? `Last price: ${[price, monthShortName].filter(Boolean).join(", ")}` : "";

  return (
    <>
      <ComponentSourcetitle>&nbsp;</ComponentSourcetitle>
      <ComponentTitle>{lastPriceTitle}</ComponentTitle>
      <div className="custom-tables-slide13-box">
        <ComponentTitle>Stock-use-ratio</ComponentTitle>
        {agGridDataStockUseRatio ? <Table className="custom-table-slide13" {...agGridDataStockUseRatio} /> : <ComponentPreloader />}

        <ComponentTitle>Month of supply</ComponentTitle>
        {agGridDataMonthOfSupply ? <Table className="custom-table-slide13" {...agGridDataMonthOfSupply} /> : <ComponentPreloader />}
      </div>
    </>
  );
};
